export default __webpack_public_path__ + "static/blob4-6a5aea5cb93bb4db03f4a3c23169fa83.svg";